import { useContext, useEffect, useState } from 'react'
import moment from 'moment'

import api from '../../services/api'
import { REPORT_TYPE_ID_MAP} from '../../constants/report'
import { StaticsContext } from '../../contexts'
import useModal from '../../hooks/useModal'

import * as S from './Main.styles'

import { ReactComponent as IntensiveIcon } from '../../assets/images/intensive_icon.svg'
import { ReactComponent as SunIcon } from '../../assets/images/sun_icon.svg'
import { ReactComponent as StudyIcon } from '../../assets/images/study_icon.svg'

export default function TodayStudy() {
  const date = moment().format('YYYY-MM-DD')
  const [ isDaily, setDaily ] = useState(true)
  const { statics, setStatics } = useContext(StaticsContext)
  const { openModal } = useModal()

  useEffect(() => {
    async function fetchData() {
      const reportTypeId = await api.get(`/reports/infos/types/${date}`)
        .then(result => result.data.reportTypeList[0].reportTypeId || REPORT_TYPE_ID_MAP.DAILY)
        .catch(e => {
          console.error(e)
          const props = {
            type: 'alert',
            props: {
              isError: true,
              contents: e.response?.data.message || e.message,
              path: e.response?.status === 404 ? '/main/planner/sessional-plan' : undefined
            }
          }
          openModal(props)
        })

      if (! reportTypeId) return
      if (REPORT_TYPE_ID_MAP.DAILY !== reportTypeId) setDaily(false)

      await api.get(`/reports/infos/performances/${date}`, { params: { reportTypeId }})
        .then(result => setStatics(result.data.statics))
        .catch(e => {
          console.error(e)
          const props = {
            type: 'alert',
            props: {
              isError: true,
              contents: e.response?.data.message || e.message
            }
          }
          if (e.response.status === 404) {
            props.props.path = '/main/planner/sessional-plan'
            openModal(props)
          } else {
            openModal(props)
          }
        })
    }
    fetchData()
  }, [])

  return (
    <>
      <S.ContentsBox height='150px'>
        <SunIcon className='title-icon' width='30px'/><S.Title fontSize='1.3em'>{isDaily ? '오늘의 스터디' : '이번 주 스터디'}</S.Title>
        <S.TodayStudyContainer>
          <S.FlexItemBox flex='4'>
            {/*달성률*/}
            {/*TODO Progressbar.jsx 컴포넌트 사용*/}
            <S.ProgressContents marginTop='10px'>
              <S.ItemName float='left' width='20%'>달성률</S.ItemName>
              <S.ProgressBar value={statics?.completionRate || 0} max='100' />
              <S.ItemName float='left' width='5%'>{statics?.completionRate || 0}%</S.ItemName>
            </S.ProgressContents>
            {/*집중도*/}
            <S.ProgressContents marginTop='70px'>
              <S.ItemName float='left' width='20%'>집중도</S.ItemName>
              <S.ProgressBar value={statics?.intensiveRate || 0} max='100' />
              <S.ItemName float='left' width='5%'>{statics?.intensiveRate || 0}%</S.ItemName>
            </S.ProgressContents>
          </S.FlexItemBox>
          {/*학습 시간*/}
          {
            isDaily ?
              <S.StudyTimeBox id='study-time-box-left'>
                <StudyIcon className='title-icon' width='25%' height='90%'/>
                <S.ItemName fontSize='1.3em'>학습 시간</S.ItemName>
                <S.Time>{statics?.studyTime || '00:00 - 00:00'}</S.Time>
              </S.StudyTimeBox>
              : <></>
          }
          {/*집중 시간*/}
          <S.StudyTimeBox>
            <IntensiveIcon className='title-icon' width='25%' height='90%'/>
            <S.ItemName fontSize='1.3em'>집중 시간</S.ItemName>
            <S.Time>
              {String(statics?.totalIntensiveTime?.hour || '00').padStart(2, '0')}
              :{String(statics?.totalIntensiveTime?.min || '00').padStart(2, '0')}
            </S.Time>
          </S.StudyTimeBox>
        </S.TodayStudyContainer>
      </S.ContentsBox>
    </>
  )
}